import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';

import { Roles } from './../../../models/auth/role';
import { PhoneNumber, User } from './../../../models/user/user';
import { PhoneNumberService } from './../../../services/phone-number.service';

@Component({
  selector: 'lana-phone-number-card',
  templateUrl: './phone-number-card.component.html',
  styleUrls: ['./phone-number-card.component.scss']
})
export class PhoneNumberCardComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private ngbModal: NgbModal,
    private phoneNumberService: PhoneNumberService
  ) {}

  @Input() user: User;
  @Output() phoneNumberAdded = new EventEmitter<PhoneNumber>();
  @Output() phoneNumberUpdated = new EventEmitter<PhoneNumber>();

  readonly roles = Roles;

  formGroup: UntypedFormGroup;
  isCurrentUser: Observable<boolean>;
  showConfirm = false;

  closeModal(formGroup: UntypedFormGroup, modal: NgbActiveModal): void {
    Object.keys(formGroup.controls).forEach((control) => {
      if (control !== 'adUserId') {
        formGroup.get(control).reset();
      }
    });
    modal.close();
    this.showConfirm = false;
  }

  confirmAddPhone(formGroup: UntypedFormGroup, modal: NgbActiveModal): void {
    if (formGroup.valid) {
      const model = formGroup.value;
      const isCreate = !model.id;
      const apiCall = isCreate
        ? this.phoneNumberService.createPhoneNumber(model)
        : this.phoneNumberService.updatePhoneNumber(model);

      apiCall
        .pipe(
          first(),
          tap((response) =>
            isCreate
              ? this.phoneNumberAdded.emit(response)
              : this.phoneNumberUpdated.emit(response)
          ),
          tap((_) => this.closeModal(formGroup, modal))
        )
        .subscribe();
    }
  }

  deletePhone(formGroup: UntypedFormGroup, modal: NgbActiveModal): void {
    this.phoneNumberService
      .deletePhoneNumber(formGroup.value.id)
      .pipe(
        first(),
        tap(() => this.phoneNumberUpdated.emit(null)),
        tap((_) => this.closeModal(formGroup, modal))
      )
      .subscribe();
  }

  openModal(
    content: any,
    formGroup: UntypedFormGroup = null,
    model: PhoneNumber = null
  ): void {
    this.ngbModal.open(content, { backdrop: 'static' });

    if (formGroup && model) {
      formGroup.patchValue(model);
      formGroup.get('phoneNumberTypeId').setValue(model.phoneNumberType.id);
    }
  }

  toggleConfirm(): void {
    this.showConfirm = !this.showConfirm;
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      id: this.formBuilder.control(null),
      adUserId: this.formBuilder.control(null, Validators.required),
      phoneNumberTypeId: this.formBuilder.control(null, Validators.required),
      number: this.formBuilder.control(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern(/\d{10}/)
        ])
      ),
      extension: this.formBuilder.control(''),
      notificationsEnabled: this.formBuilder.control(true)
    });

    if (this.user) {
      this.formGroup.get('adUserId').setValue(this.user.id);
    }

    // this.isCurrentUser = this.user
    //   ? this.authService.currentUser$.pipe(map(({ id }) => this.user.id === id))
    //   : of(false);
  }
}
